import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { slides } from '@/mocks/slides';

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const current = slides[index];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const goTo = (next: number) => {
    setIndex(((next % slides.length) + slides.length) % slides.length);
  };

  const detailLink = current.type === 'tv' ? `/detail/tv/${current.targetId}` : `/detail/news/${current.targetId}`;

  return (
    <section className="relative h-[460px] w-full overflow-hidden md:h-[600px]" aria-label="焦点推荐">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? 'opacity-100' : 'pointer-events-none opacity-0'
          }`}
          aria-hidden={i !== index}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 我妻子的一切影视资讯`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/65 to-primary-950/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent" />

      <div className="absolute inset-0 flex items-center">
        <div className="mx-auto w-full max-w-site px-4 md:px-6">
          <div className="mb-4 flex items-center gap-3">
            <span className="h-px w-10 bg-accent-400" />
            <h1 className="font-heading text-sm font-bold tracking-[0.2em] text-accent-400 md:text-base">
              我妻子的一切 · 影视资讯站
            </h1>
          </div>

          <div key={current.id} className="max-w-2xl animate-fade-up">
            <span className="inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-label text-primary-950">
              {current.badge}
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-5xl">
              {current.title}
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              {current.subtitle}
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to={detailLink}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-play-circle-line text-lg" />
                查看详情
              </Link>
              <Link
                to="/category/电视剧"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/60 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-movie-2-line text-lg" />
                浏览全部剧集
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-4 flex items-center gap-3 md:right-6">
        <button
          type="button"
          onClick={() => goTo(index - 1)}
          aria-label="上一张"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/50 text-background-50 transition-colors hover:bg-background-50/15"
        >
          <i className="ri-arrow-left-s-line text-lg" />
        </button>
        <button
          type="button"
          onClick={() => goTo(index + 1)}
          aria-label="下一张"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/50 text-background-50 transition-colors hover:bg-background-50/15"
        >
          <i className="ri-arrow-right-s-line text-lg" />
        </button>
      </div>

      <div className="absolute bottom-7 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => goTo(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === index ? 'w-8 bg-accent-500' : 'w-3 bg-background-100/60'
            }`}
          />
        ))}
      </div>
    </section>
  );
}